"use client";
import React, {createContext, useState, useEffect, useRef, useContext} from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
// import { FullPage, Slide } from 'react-full-page';
// @ts-ignore
import {FullPage, Slide} from 'react-full-page';
import {FullPageContext} from "./FullPageContext"; // Context import
import {useLocation} from "react-router-dom";

import { GlobalRefProvider } from './GlobalRefContext';
import Header from './components/Header';
import Section00 from './components/Section00';
import Section01 from './components/Section01';
import Section01_m from './components/Section01_m';
import SectionLand from './components/SectionLand';
import Section02 from './components/Section02';
// import Section03 from './components/Section03';
import Section04 from './components/Section04';
// import Section05 from './components/Section05_main';
import Section05 from './components/Section05_main';
import LoginModal from './components/LoginModal';
import JoinModal from './components/JoinModal';
import Merge from './pages/Merge';
import ProductDetail from './pages/ProductDetail';
import ProductBuy from './pages/ProductBuy';
import ProductBuy2 from './pages/ProductBuy2';
import EventDetail from './pages/EventDetail';
import Payment from "./pages/Payment";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFail from "./pages/PaymentFail";
import TradeRegistration from './pages/TradeRegistration';
import PurchaseHistory from "./pages/PurchaseHistory";
import ProtectedRoute from "./ProtectedRoute";
import TermsOfUse2 from "./pages/TermsOfUse2";
import PrivacyPolicyPage from"./pages/PrivacyPolicyPage";
import TermsPage from"./pages/TermsPage";
import useOrientation from "./pages/useOrientation";
import FullPageScroll from "./pages/FullPageScroll";

import {
    FullpageContainer,
    FullpageSection,
} from '@shinyongjun/react-fullpage';


// import './App.css';
import './css/components/Modal.css';
// API URL 설정

//export const ApiContext = createContext<string>('https://testapi.baekhoeleven.com');
// export const ApiContext = createContext<string>('https://api.l-and.shop');
//https://apidevtest.l-and.shop"
export const ApiContext = createContext<string>('https://api.l-and.shop');
// export const ApiContext = createContext<string>('https://apidevtest.l-and.shop');

const App: React.FC = () => {
    const apiUrl = useContext(ApiContext);

    const isIPad = /ipad/.test(navigator.userAgent.toLowerCase()) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    const isAndroidTablet = navigator.userAgent.toLowerCase().includes("android") &&
        !navigator.userAgent.toLowerCase().includes("mobile");

    const [isMobile, setIsMobile] = useState(
        (window.innerWidth <= 767 && !isIPad && !isAndroidTablet) || false
    );

    //const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [backgroundImage, setBackgroundImage] = useState<string>('');
    const [isLoginModalOpen, setIsLoginModalOpen] = useState<boolean>(false);
    const [isJoinModalOpen, setIsJoinModalOpen] = useState<boolean>(false);
    const [bg_img2, setBgimg2] = useState<string>('');
    const [bg_img3, setBgimg3] = useState<string>('');
    const [visibleSlide, setVisibleSlide] = useState<boolean>(true);
    const fullPageRef = useRef(null); // FullPage에 접근하기 위한 ref

    useEffect(() => {
        document.body.style.backgroundImage = `url(${backgroundImage})`;
        document.body.style.backgroundSize = '100% 100%';

        return () => {
            document.body.style.backgroundImage = '';
            document.body.style.backgroundSize = '';
        };
    }, [backgroundImage]);




    const setHeightAuto = () => {
        const lastSection = document.querySelector('.lastSection') as HTMLElement;
        if (lastSection) {
            lastSection.style.height = 'auto';
            lastSection.style.bottom = '0px';
        }
    };

    useEffect(() => {
        const handleResize = () => {

            const isIPad = /iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchstart' in window;
            const isNowMobile = window.innerWidth <= 767 && !isIPad;

            if (isNowMobile !== isMobile) {
                // 모바일/아이패드/PC 상태가 변경될 때 API 호출
                setIsMobile(isNowMobile);
            }
        };

        const callApi = async ({deviceType}: { deviceType: any }) => {
            // 실제 API 호출 로직을 여기에 작성하세요
            // 예: fetch('/api/endpoint', { method: 'POST', body: JSON.stringify({ deviceType }) });
            try {
                const endpoint = deviceType === 'Mobile'
                    ? `${apiUrl}/api/main/thumbnail/mobile`
                    : `${apiUrl}/api/main/thumbnail/pc`;

                const response = await fetch(endpoint);

                if (!response.ok) {
                    console.error('Network error:', response.statusText);
                    return;
                }

                const result = await response.json();

                // setBgimg1(result.data.introMainImage);
                setBgimg2(result.data.backgroundImage);
                setBgimg3(result.data.backgroundImage);
                // setBgimg4(result.data.mergeImagePath);

            } catch (error) {
                console.error('Error fetching thumbnail images:', error);
            }
        };

        // 초기 상태에 따라 API 호출
        callApi({deviceType: isMobile ? "Mobile" : "PC"});

        window.addEventListener("resize", handleResize);

        // cleanup
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [isMobile]);


    const goToSection = (index: number) => {

        if(isMobile){
            scrollToElement(index);
        }else{

            if (typeof index === "number") {
                // @ts-ignore
                fullPageRef.current?.scrollToSlide(index);
            }
        }


    };

    const scrollToElement = (id: number | undefined) => {
        const sectionIds = ["section00", "shop", "land"]; // index에 따라 매칭될 ID 리스트
        // @ts-ignore
        const targetId = sectionIds[id]; // index에 맞는 ID 가져오기

        if (!targetId) return; // index가 범위를 벗어나면 함수 종료

        const element = document.getElementById(targetId);
        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
            console.warn(`Element with ID "${targetId}" not found.`);
        }
    };



    const HomePage = () => {
        const s_index = sessionStorage.getItem('s_index'); // 'key'에 해당하는 값을 가져옴
        const [s_move, setSMove] = useState<boolean>(false);
        const isMobile2 = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
        const [visibleModal1, setVisibleModal1] = useState<boolean>(false);
        // const [currentSlide, setCurrentSlide] = useState(0);


        const location = useLocation();
        const [currentSlide, setCurrentSlide] = useState(0);

        const [isAnchorClicked, setIsAnchorClicked] = useState(false);

        // 🔹 해시값(#land, #shop 등)에 따라 슬라이드 이동
        useEffect(() => {
            const hash = location.hash;
            const slideMap: { [key: string]: number } = {
                "#land": 2,  // land → 2번째 슬라이드
                "#shop": 1,  // shop → 1번째 슬라이드
                "#prologue": 0,  // prologue → 0번째 슬라이드
            };

            if (fullPageRef.current && slideMap[hash] !== undefined) {
                // 세션 스토리지에서 값 확인
                const clicked = sessionStorage.getItem("clicked");

                if (clicked) {
                    // 세션 스토리지에 값이 있으면 즉시 슬라이드 이동
                    if(!isMobile){
                        // @ts-ignore
                        // fullPageRef.current.scrollToSlide(slideMap[hash]);
                        goToSection(slideMap[hash]);
                        sessionStorage.removeItem('clicked');
                    }


                } else {
                    // 세션 스토리지에 값이 없으면 setTimeout 사용
                    setTimeout(() => {
                        if(!isMobile){
                            // @ts-ignore
                            // fullPageRef.current.scrollToSlide(slideMap[hash]);
                            goToSection(slideMap[hash]);
                        }
                    }, 2000); // 1초 (1000ms) 딜레이
                }
            }


        }, [location.hash]);

        // useEffect(() => {
        //     // if (s_move) {
        //     if (s_index) {
        //         // @ts-ignore
        //         // fullPageRef.current?.scrollToSlide(s_index);
        //         const timer = setTimeout(() => {
        //             // 2초 후에 scrollToSlide 호출
        //             // @ts-ignore
        //             fullPageRef.current?.scrollToSlide(Number(s_index));
        //
        //             sessionStorage.removeItem('s_index'); // 'key' 값을 삭제
        //
        //         }, 1000); // 2000ms = 2초
        //
        //         // 컴포넌트가 unmount되거나 s_index나 section이 변경될 때 timer를 정리
        //         return () => clearTimeout(timer);
        //     }
        //     // }
        //
        // }, [s_index, s_move]);


        const { isLandscape, isPortrait } = useOrientation();

        useEffect(() => {
            // 가로모드에서 세로모드로 변경된 경우
            if (isLandscape && !isPortrait) {
                // @ts-ignore
                const index = fullPageRef?.current.getCurrentSlideIndex();
                // @ts-ignore
                fullPageRef.current?.scrollToSlide(index);
            }

            // 세로모드에서 가로모드로 변경된 경우
            if (!isLandscape && isPortrait) {
                // @ts-ignore
                const index = fullPageRef?.current.getCurrentSlideIndex();

                // @ts-ignore
                fullPageRef.current?.scrollToSlide(index);
            }


        }, [isLandscape, isPortrait]); // isLandscape, isPortrait 값이 변경될 때마다 실행

        // @ts-ignore
        return (
            <>
                {/*<Header/>*/}
                <div className="App"
                     onLoad={() => {
                         setHeightAuto();
                     }}
                    // @ts-ignore
                     onChange={({ from, to }: { from: number; to: number }) => setCurrentSlide(to)}
                >

                    <FullPage
                        ref={fullPageRef}
                        scrollMode={!isMobile2 ? 'full-page':'normal'}
                    >
                        <Header/>
                        <Slide>
                            {!isMobile ? <Section00/> : <Section01/>}
                        </Slide>
                        {visibleSlide &&
                            <Slide><Section02 bg_img2={bg_img2} setVisibleSlide={setVisibleSlide}/></Slide>
                        }
                        <Slide><SectionLand bg_img3={bg_img3}/></Slide>
                        <Slide className={"lastSection"}><Section05/></Slide>
                    </FullPage>

                    {/* 모달 상태에 따라 표시 */}
                    {/*<LoginModal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)}/>*/}
                    {/*<JoinModal isOpen={isJoinModalOpen} onClose={() => setIsJoinModalOpen(false)}/>*/}
                    {isLoginModalOpen &&
                        <LoginModal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)}/>}
                    {isJoinModalOpen && <JoinModal isOpen={isJoinModalOpen} onClose={() => setIsJoinModalOpen(false)}/>}
                </div>
            </>
        );
    };

    const HomePage2 = () => {
        const s_index2 = sessionStorage.getItem('s_index'); // 'key'에 해당하는 값을 가져옴
        const [s_move, setSMove] = useState<boolean>(false);
        const isMobile2 = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
        const [visibleModal1, setVisibleModal1] = useState<boolean>(false);


        useEffect(() => {
            // if (s_move) {
            if (s_index2) {
                // @ts-ignore
                // fullPageRef.current?.scrollToSlide(s_index);
                const timer = setTimeout(() => {
                    // 2초 후에 scrollToSlide 호출
                    // @ts-ignore
                    scrollToElement(s_index2);

                    sessionStorage.removeItem('s_index'); // 'key' 값을 삭제

                }, 1000); // 2000ms = 2초

                // 컴포넌트가 unmount되거나 s_index나 section이 변경될 때 timer를 정리
                return () => clearTimeout(timer);
            }
            // }

        }, [s_index2, s_move]);


        return (
            <>
                {/*<Header/>*/}
                <div className="App" >
                    <Header/>
                    <div>
                        {!isMobile ? <Section00/> : <Section01/>}
                    </div>
                    {visibleSlide &&
                        <div style={{height : '100vh'}}><Section02 bg_img2={bg_img2} setVisibleSlide={setVisibleSlide}/></div>
                    }
                    <div style={{height : '100vh'}}>
                        <SectionLand bg_img3={bg_img3}/>
                    </div>
                    <div>
                        <Section05/>
                    </div>




                    {/* 모달 상태에 따라 표시 */}
                    {/*<LoginModal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)}/>*/}
                    {/*<JoinModal isOpen={isJoinModalOpen} onClose={() => setIsJoinModalOpen(false)}/>*/}
                    {isLoginModalOpen && <LoginModal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)}/>}
                    {isJoinModalOpen && <JoinModal isOpen={isJoinModalOpen} onClose={() => setIsJoinModalOpen(false)}/>}
                </div>
            </>
        );
    };

    return (
        //http://localhost:9012
        //https://api.l-and.shop
        //https://apidevtest.l-and.shop

        <ApiContext.Provider value="https://api.l-and.shop">
            <FullPageContext.Provider value={{goToSection}}>
                <Router>
                    <Routes>
                        {/*<Route path="/" element={<ProductBuy2/>}/>*/}
                        <Route path="/" element={isMobile ? <HomePage2/> : <HomePage/>}/>
                        <Route path="/merge" element={<Merge/>}/>
                        <Route path="/pages/ProductDetail/:seqNo" element={<ProductDetail/>}/>
                        <Route path="/pages/ProductBuy/:seqNo" element={<ProductBuy/>}/>
                        <Route path="/pages/PrivacyPolicyPage" element={<PrivacyPolicyPage/>}/>
                        <Route path="/pages/termsPage" element={<TermsPage/>}/>
                        {/*<Route path="/pages/ProductBuy/:seqNo" element={<ProductBuy2/>}/>*/}
                        <Route path="/pages/Payment" element={<ProtectedRoute><Payment/></ProtectedRoute>}/>
                        <Route path="/pages/TradeReg" element={<ProtectedRoute><TradeRegistration/></ProtectedRoute>}/>
                        <Route path="/pages/success" element={<ProtectedRoute><PaymentSuccess/></ProtectedRoute>}/>
                        <Route path="/pages/fail" element={<ProtectedRoute><PaymentFail/></ProtectedRoute>}/>
                        <Route path="/pages/PaymentDetails"
                               element={<ProtectedRoute><PurchaseHistory/></ProtectedRoute>}/>
                    </Routes>
                </Router>
            </FullPageContext.Provider>
        </ApiContext.Provider>
    );
};

export default App;